import { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";

const CHECK_MS = 5 * 60 * 1000;
const fingerprint = (html) => (html.match(/\/static\/js\/[^"']+\.js/g) || []).sort().join("|");

export function UpdateNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const current = fingerprint(Array.from(document.scripts).map((s) => `"${s.src}"`).join(" "));
    if (!current) return undefined;
    const check = async () => {
      try {
        const html = await (await fetch(`/index.html?t=${Date.now()}`, { cache: "no-store" })).text();
        const latest = fingerprint(html);
        if (latest && latest !== current) setShow(true);
      } catch { /* offline */ }
    };
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    const id = setInterval(check, CHECK_MS);
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-5 right-5 z-[100] w-[min(22rem,calc(100vw-2.5rem))] bg-slate-900 text-white rounded-xl shadow-2xl p-4 flex gap-3 items-start animate-in slide-in-from-bottom-4" role="status" data-testid="update-notice">
      <RefreshCw size={20} className="text-emerald-400 shrink-0 mt-0.5" />
      <div className="flex-1">
        <div className="font-semibold text-sm">Neue Version verfügbar</div>
        <p className="text-xs text-slate-300 mt-0.5">Die App wurde aktualisiert. Bitte neu laden, um die aktuelle Version zu nutzen.</p>
        <button onClick={() => window.location.reload()} className="mt-3 bg-white text-slate-900 text-sm font-semibold px-4 py-1.5 rounded-lg hover:bg-slate-100 transition-colors" data-testid="update-notice-reload">Neu laden</button>
      </div>
      <button onClick={() => setShow(false)} className="text-slate-400 hover:text-white" title="Später" data-testid="update-notice-dismiss"><X size={16} /></button>
    </div>
  );
}
